


















































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import { fetchRegistrar } from './fetchRegistrar';
import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Console } from 'console';
import ProcesarSeleccion from './ModalProcesar/ProcesarSeleccion.vue';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';

@Component({
  components: {
    MantenedorGrid,
    DatePicker,
    Confirmation,
    FormFieldsContainer,
    ModalProcesar: ProcesarSeleccion,
    PopUpGeneratedReports,
  },
})
export default class RegistrarBajaSim extends ComponenteBase {
  dialogConfirmacionClose: boolean = false;
  filtro: string = '';
  ordesList: any[] = [];
  showModal: boolean = false;
  today: string = moment().format('YYYY-MM-DD');

  showPopUpReport: boolean = false;
  msgReport: string = '';

  funcionalidad: Funcionalidades = Funcionalidades.RegistrarBajaSim;

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      value: '',
      id: '',
    },
    motivo: {
      label: 'Motivo',
      value: '',
      id: '',
    },
    dateStart: {
      label: 'Fecha Envío Desde',
      value: moment()
        .subtract(1, 'month')
        .startOf('day'),
      id: '',
    },
    dateEnd: {
      label: 'Fecha Envío Hasta',
      value: moment().endOf('day'),
      id: '',
    },
  };
  selecteds: any;
  procesarSeleccion() {
    this.selecteds = this.gridApi.getSelectedRows();
    if (this.selecteds.length == 0) {
      this.$snotify.error('Por favor seleccione al menos una solicitud', {
        timeout: 3000,
      });
      return;
    }
    this.showModal = true;
  }

  clearFilters() {
    this.formFields.dateStart.value = moment()
      .subtract(1, 'months')
      .startOf('day');
    this.formFields.dateEnd.value = moment().endOf('day');
    this.formFields.estado.value = '';
    this.formFields.motivo.value = '';
  }

  async getSolicitudes() {
    let self = this;
    this.loadingService.showLoading();
    return fetchRegistrar(
      {
        fechaInicio: moment(this.formFields.dateStart.value.toString())
          .startOf('day')
          .format('YYYY/MM/DD HH:mm'),
        fechafin: moment(this.formFields.dateEnd.value.toString())
          .endOf('day')
          .format('YYYY/MM/DD HH:mm'),
        estado: this.formFields.estado.value
          ? this.formFields.estado.value
          : '',
        motivo: this.formFields.motivo.value
          ? this.formFields.motivo.value
          : '',
      },
      'conecta_registra_baja_sim/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  estados: any = ['Ejecutado', 'Solicitado'];
  motivos: any = [];
  async getFilter() {
    let self = this;
    return fetchRegistrar(
      { '': '' },
      'solicitud_baja_sim_por_tarjeta/get_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.motivos = data.data.MOTIVOS;
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ocurrió un error al cargar la información de los filtros',
          {
            timeout: 3000,
          }
        );
      });
  }

  async filtrar() {
    if (this.formFields.dateStart.value > this.formFields.dateEnd.value) {
      this.$snotify.error(
        'La fecha de inicio no puede ser superior a la fecha fin',
        {
          timeout: 3000,
        }
      );
      return;
    }
    this.ordesList = await this.getSolicitudes();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getSolicitudes();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  ProcesarSeleccion: PermisoAccion = {
    accionCodigo: 107,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.ProcesarSeleccion,
  ];

  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  loadingService = new LoadingService();
  handleErrors: HandleErrors = new HandleErrors();
  AccionesPerfilesAsociados: number = 0;

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  //showModalNew: boolean = false;
  modalEsEdicion: boolean = false;

  isRowSelectable(node: any): boolean {
    return node.data ? node.data.estado === 'Solicitado' : false;
  }

  dateFormatter(params: any) {
    return params && params.movifecha_recibe != ''
      ? moment(params.value).format('YYYY/MM/DD HH:mm:ss')
      : '';
  }

  constructor() {
    super();

    this.columnDefs = [
      {
        minWidth: 70,
        width: 75,
        checkboxSelection: true,
      },
      {
        headerName: 'Número',
        field: 'sbajasimnumero',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 150,
        width: 150,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Creación',
        field: 'sbajasimfecha_alta',
        resizable: true,
        sortable: true,
        width: 220,
        minWidth: 220,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Usuario',
        field: 'full_name',
        sortable: true,
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Motivo',
        field: 'motivo',
        width: 300,
        minWidth: 300,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Observación',
        field: 'sbajasimobs',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Fecha Ejecuta',
        field: 'sbajasimfecha_ejecuta',
        resizable: true,
        sortable: true,
        width: 225,
        minWidth: 225,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Cantidad',
        field: 'sbajacantsim',
        resizable: true,
        width: 120,
        minWidth: 120,
        lockPinned: true,
        sortable: true,
      },
    ];

    this.gridOptions = {
      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      rowSelection: 'multiple',
      isRowSelectable: this.isRowSelectable,
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  mounted() {
    this.getFilter();
  }

  moduloModalCallback(val: boolean) {
    this.showModal = val;
    this.modalEsEdicion = val;
    this.filtrar();
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  async getCSV(): Promise<void> {
    const self = this;

    const paramsApi: any = {};

    for (const key in self.formFields) {
      if (self.formFields.hasOwnProperty(key) && self.formFields[key].value) {
        paramsApi[key] = self.formFields[key].value;
      }
    }
    const user = localStorage.getItem('user');
    const userId = JSON.parse(user.replace(/'/g, '"')).id;
    const clienteDefecto = localStorage.getItem('clienteDefecto');

    self.loadingService.showLoading();

    return await fetchRegistrar(
      {
        userId,
        clienteDefecto,
        ...paramsApi,
      },
      'conecta_registra_baja_sim/export_excel'
    )
      .then((response: any) => {
        self.loadingService.showLoading();
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return;
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
}
